import { useState } from "react";
import {
  Truck, Container, Layers, ArrowLeftRight, Globe,
  Package, Mountain, Warehouse, Zap, HardHat, ArrowRight,
} from "lucide-react";
import { SERVICES } from "../data/mock";
import { Button } from "./ui/button";

const iconMap = {
  Truck, Container, Layers, ArrowLeftRight, Globe,
  Package, Mountain, Warehouse, Zap, HardHat,
};

export const ServicesSection = () => {
  const [showAll, setShowAll] = useState(false);
  const displayItems = showAll ? SERVICES.items : SERVICES.items.slice(0, 6);

  const scrollToQuote = () => {
    const el = document.querySelector("#quote");
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section id="services" className="py-20 lg:py-28 bg-[hsl(220,25%,97%)]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <div className="inline-flex items-center gap-2 bg-navy-50 border border-navy-100/80 rounded-full px-4 py-1.5 mb-6">
            <Truck size={13} className="text-hevi-blue" />
            <span className="text-hevi-blue font-semibold text-[11px] uppercase tracking-[0.15em]">
              {SERVICES.label}
            </span>
          </div>
          <h2 className="text-3xl sm:text-4xl lg:text-[2.75rem] font-extrabold text-navy-900 leading-tight mb-5">
            COMPREHENSIVE <span className="text-hevi-red">TRUCKING SOLUTIONS</span> — ONE CALL DOES IT ALL
          </h2>
          <p className="text-lg text-slate-400 leading-relaxed">
            {SERVICES.subheadline}
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5 lg:gap-6">
          {displayItems.map((service, i) => {
            const Icon = iconMap[service.icon];
            return (
              <div
                key={i}
                className="group relative bg-white rounded-2xl border border-slate-200/60 overflow-hidden card-premium hover:shadow-xl transition-all duration-500 cursor-pointer"
                onClick={scrollToQuote}
              >
                {/* Image */}
                <div className="relative h-48 overflow-hidden">
                  <img
                    src={service.image}
                    alt={service.title}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700 ease-out"
                  />
                  <div className="absolute inset-0" style={{ background: 'linear-gradient(to top, rgba(7,14,36,0.7) 0%, rgba(7,14,36,0.2) 50%, transparent 100%)' }} />
                  <div className="absolute bottom-3 left-4">
                    <div className="w-9 h-9 rounded-lg bg-white/15 backdrop-blur-lg border border-white/20 flex items-center justify-center">
                      {Icon && <Icon size={17} className="text-white" />}
                    </div>
                  </div>
                </div>
                {/* Content */}
                <div className="p-6">
                  <h3 className="text-[15px] font-bold text-navy-900 mb-2 group-hover:text-hevi-blue transition-colors duration-300">
                    {service.title}
                  </h3>
                  <p className="text-slate-400 text-[13.5px] leading-relaxed line-clamp-3">
                    {service.description}
                  </p>
                  <div className="mt-4 flex items-center gap-1.5 text-hevi-blue font-semibold text-xs opacity-0 group-hover:opacity-100 translate-y-1 group-hover:translate-y-0 transition-all duration-300">
                    Get a Quote <ArrowRight size={12} />
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        {/* Show More */}
        {!showAll && SERVICES.items.length > 6 && (
          <div className="text-center mt-12">
            <Button
              variant="outline"
              onClick={() => setShowAll(true)}
              className="border border-navy-200/80 text-navy-700 hover:bg-navy-50 font-semibold px-8 h-12 rounded-xl transition-all duration-300 text-sm"
            >
              View All {SERVICES.items.length} Services
              <ArrowRight size={15} className="ml-2" />
            </Button>
          </div>
        )}
      </div>
    </section>
  );
};
